import React, { useMemo } from "react";
import { DemographicsTextCardProps } from "./types";

import * as styles from "./styles";

export const DemographicsTextCard: React.FC<DemographicsTextCardProps> = ({
  options: { title, values },
}) => {
  const config = useMemo(() => {
    const isSingleItem = Boolean(values?.length === 1);

    return {
      isSingleItem,
    };
  }, [values]);

  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <div className={styles.values}>
        {values?.map(({ icon: Icon, ...item }) => (
          <div
            key={item.variable}
            className={styles.item}
            data-is-single={config.isSingleItem}
          >
            <div className={styles.valueLabel}>
              {config.isSingleItem && typeof Icon !== "undefined" && (
                <Icon
                  className={styles.icon}
                  width={config.isSingleItem ? 32 : 16}
                  height={config.isSingleItem ? 32 : 16}
                />
              )}
              {!config.isSingleItem && (
                <p className={styles.multipleItemLabel}>{item.label}</p>
              )}
            </div>
            {config.isSingleItem ? (
              <h2 className={styles.singleItemText}>{item.value}</h2>
            ) : (
              <p className={styles.multipleItemText}>{item.value}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
